<div class="div-st">


    <h1 class="st-h1" translate>{{"Consultations récentes"|translate}}</h1>
    <span layout="row">
    <hr class="st-hr" flex/>
  </span>

    <mdb-carousel #carousel [isControls]="true" [ngSwitch]="carouselDisplayMode"
                  [type]="'carousel-multi-item'" class="carousel-multi-item multi-animation carousel">
        <ng-container *ngSwitchCase="'single'">
            <mdb-carousel-item *ngFor="let card of listconsultations" style="padding-left: 30%; padding-right: 30%;">
                <mdb-card class="my-1">

                    <mdb-card-body>
                        <mdb-card-title>
                            <h4
                                    style="height: 20%; overflow: hidden;
                  text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;font-weight: bold; font-size: 17px;"
                                    translate>{{card.instNm}}</h4>
                            <!-- <u translate style="padding-top: -2%;">{{card.generalYn}}</u> -->
                        </mdb-card-title>
                        <p class="st-font"
                           style=" height: 18%; padding-top: 3%;
                overflow: hidden;
                text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" translate><b translate>Objet : </b>{{card.shopNmFr}}</p>
                        <!-- <p  style="  height: 20%;
                        overflow: hidden;
                     display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" class="st-font" translate> <b translate>Catégorie : </b>{{card.pbkStrFr}}</p> -->
                        <p class="st-font" style=" height: 20%; text-align: center; padding-top: 6%;
               " translate><b style="color: tomato;" translate>Dernier délai
                            :</b>{{card.publicDt | date: 'dd/MM/yyyy'}}</p>
                        <div style="justify-content: center ;text-align: center !important;">
                            <button (click)="detailsconsultation(card)" class="waves-light st-butt-plusinfo-responsive"
                                    mdbWavesEffect

                                    translate>Plus d'informations
                            </button>
                        </div>
                    </mdb-card-body>
                </mdb-card>
            </mdb-carousel-item>
            <div>
                <a (click)="prev()" class="carousel-control-prev" data-slide="prev" role="button" style="width: 10%;">
                    <span aria-hidden="true" class="carousel-control-prev-icon"></span>

                </a>
                <a (click)="next()" class="carousel-control-next" data-slide="next" role="button" style="width: 10%;">
                    <span aria-hidden="true" class="carousel-control-next-icon"></span>

                </a>
            </div>
        </ng-container>

        <ng-container *ngSwitchCase="'multiple'">
            <mdb-carousel-item *ngFor="let item of slides; let i = index" class="test">
                <div *ngFor="let card of item; let cardIndex = index" class="col-md-4">
                    <mdb-card class="my-1">

                        <mdb-card-body>
                            <mdb-card-title>
                                <h4
                                        style="height: 20%; overflow: hidden;
                  text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;font-weight: bold; font-size: 17px;"
                                        translate>{{card.instNm}}</h4>
                                <!-- <u translate style="padding-top: -2%;">{{card.generalYn}}</u> -->
                            </mdb-card-title>
                            <p class="st-font"
                               style=" height: 19%; padding-top: 3%;
                overflow: hidden;
                text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" translate><b translate>Objet </b><b> : </b>{{card.shopNmFr}}</p>
                            <!-- <p  style="  height: 20%;
                            overflow: hidden;
                         display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" class="st-font" translate> <b translate>Catégorie : </b>{{card.pbkStrFr}}</p> -->
                            <p class="st-font"
                               style=" height: 20%; text-align: center; padding-top: 6%;
                overflow: hidden;
               text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;" translate><b style="color: tomato;" translate>Dernier délai
                            </b><b> : </b>{{card.publicDt | date: 'dd/MM/yyyy'}}</p>
                            <div style="justify-content: center ;text-align: center !important;">
                                <button (click)="detailsconsultation(card)" class="waves-light st-butt-plusinfo"
                                        mdbWavesEffect

                                        translate>Plus d'informations
                                </button>
                            </div>
                        </mdb-card-body>
                    </mdb-card>
                </div>
            </mdb-carousel-item>
            <div>
                <a (click)="prev()" class="carousel-control-prev" data-slide="prev" role="button">
                    <span aria-hidden="true" class="carousel-control-prev-icon"></span>

                </a>
                <a (click)="next()" class="carousel-control-next" data-slide="next" role="button">
                    <span aria-hidden="true" class="carousel-control-next-icon"></span>

                </a>
            </div>
        </ng-container>

    </mdb-carousel>

</div>
<div style="background-color: #f4f4f4;">
    <div style="text-align:center;padding-bottom: 3%; padding-top: 3%;">
        <button (click)="verstouslesconsultations()" class="butt-afficher" color="primary" mat-flat-button
        >{{"Afficher toutes les consultations"|translate}}</button>
    </div>

</div>
